import camelCase from 'lodash.camelcase';
import i18n from 'i18n';
import { FormTemplateField, FormTemplateOption } from 'data/template/template.types';
import cloneDeep from 'lodash.clonedeep';

export function localizeLabel(
  name: string,
  defaultLabel: string | undefined,
  i18nKeyPrefix?: string,
  localizationDisabled?: boolean,
): string | undefined {
  return localizeField(
    name,
    'field',
    defaultLabel,
    i18nKeyPrefix,
    localizationDisabled,
  );
}

export function localizePlaceholder(
  name: string,
  defaultPlaceholder: string | undefined,
  i18nKeyPrefix?: string,
  localizationDisabled?: boolean,
): string | undefined {
  return localizeField(
    name,
    'fieldPlaceholder',
    defaultPlaceholder,
    i18nKeyPrefix,
    localizationDisabled,
  );
}

function localizeField(
  name: string,
  fieldKey: string,
  defaultValue: string | undefined,
  i18nKeyPrefix?: string,
  localizationDisabled?: boolean,
): string | undefined {
  if (localizationDisabled || defaultValue == null || defaultValue === '') {
    return defaultValue;
  }

  const value = i18n.t([
    `${i18nKeyPrefix}.${fieldKey}.${name}.${camelCase(defaultValue)}`,
    `${i18nKeyPrefix}.${fieldKey}.${name}`,
  ], defaultValue);

  return value;
}

export function localizeGroup(
  defaultValue: string | undefined,
  i18nKeyPrefix?: string,
  localizationDisabled?: boolean,
): string | undefined {
  if (localizationDisabled || defaultValue == null || defaultValue === '') {
    return defaultValue;
  }

  const i18nKeySuffix = camelCase(defaultValue);

  const value = i18n.t([
    `${i18nKeyPrefix}.group.${i18nKeySuffix}`,
  ], defaultValue);

  return value;
}

export function localizeOptions(
  name: string,
  field: FormTemplateField,
  i18nKeyPrefix?: string,
  localizationDisabled?: boolean,
): FormTemplateOption[] | undefined {
  const { optionsTranslatable, optionsFirstTranslatable, options } = field;

  if (localizationDisabled || options == null || !Array.isArray(options)) {
    return options;
  }

  let maybeClonedOptions = options;
  if (optionsTranslatable || optionsFirstTranslatable) {
    maybeClonedOptions = cloneDeep(options);
  }

  let translatableOptions: FormTemplateOption[] = [];
  if (optionsTranslatable) {
    translatableOptions = maybeClonedOptions;

  } else if (optionsFirstTranslatable) {
    translatableOptions = maybeClonedOptions.slice(0, 1);
  }

  translatableOptions.forEach((option) => {
    if (option?.label != null) {
      option.label = i18n.t([
        `${i18nKeyPrefix}.fieldOption.${name}.${camelCase(option.label)}`,
      ], option.label);
    }
  });

  return maybeClonedOptions;
}
